import type React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { useMediaQuery } from '#src/app/shared/hooks/dom';

import type { VideoFirstViewport } from '../../hooks/useVideoFirstHero';

const DESKTOP_MEDIA_QUERY = '(min-width: 768px)';

const TikTokPlayerClient: React.FC<Props> = ({ playerUrl, title, viewport }) => {
	const initialIsDesktop = window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
	const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY, initialIsDesktop);
	const matchesViewport = viewport === (isDesktop ? 'desktop' : 'mobile');

	if (!matchesViewport) return null;

	return (
		<iframe
			src={playerUrl}
			title={title}
			className="h-full w-full border-0"
			allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
			allowFullScreen
			referrerPolicy="strict-origin-when-cross-origin"
		/>
	);
};

export const TikTokPlayer: React.FC<Props> = (props) => {
	return <ClientRender>{() => <TikTokPlayerClient {...props} />}</ClientRender>;
};

type Props = {
	playerUrl: string;
	title: string;
	viewport: VideoFirstViewport;
};
